// Custom sorting by lastreceive tag - UPDATED
class CustomProductSorter {
  constructor() {
    this.originalProductOrder = [];
    this.init();
  }

  init() {
    console.log('🚀 Initializing CustomProductSorter...');
    
    // Store the original product order immediately
    this.storeOriginalProductOrder();
    
    // Add custom sort option to the sort dropdown
    this.addCustomSortOption();
    
    // Listen for sort changes
    this.bindSortEvents();
    
    // Check if URL already has lastreceive sorting
    this.checkForExistingLastReceiveSort();
    
    // Test if our custom option exists
    setTimeout(() => {
      const customInput = document.querySelector('input[value="lastreceive"]');
      if (customInput) {
        console.log('✅ Custom sort option found:', customInput);
      } else {
        console.log('❌ Custom sort option not found!');
      }
    }, 2000);
  }

  storeOriginalProductOrder() {
    console.log('📦 Storing original product order...');
    
    // Try multiple selectors to find the product grid
    const selectors = [
      '.collection__products',
      '.collection__grid',
      '.products-grid',
      '.collection-products',
      '[data-collection-products]',
      '.collection__items',
      '.collection__products-grid',
      '.collection__grid-container',
      '.collection__products-container',
      '.collection__items-grid'
    ];
    
    let productGrid = null;
    for (const selector of selectors) {
      productGrid = document.querySelector(selector);
      if (productGrid) {
        console.log(`✅ Found product grid using selector: ${selector}`);
        break;
      }
    }
    
    if (!productGrid) {
      console.log('❌ No product grid found for storing original order');
      return;
    }

    // Find products using the same methods as in sortByLastReceive
    let products = [];
    
    // Method 1: Direct children
    products = Array.from(productGrid.children).filter(child => 
      child.hasAttribute('data-product-id') || 
      child.classList.contains('product-grid-item') ||
      child.classList.contains('grid__item')
    );
    
    // Method 2: If no products found, try querySelectorAll
    if (products.length === 0) {
      products = Array.from(productGrid.querySelectorAll('[data-product-id]'));
    }
    
    // Method 3: If still no products, try broader selectors
    if (products.length === 0) {
      products = Array.from(productGrid.querySelectorAll('.product-grid-item, .grid__item, [data-product-block]'));
    }
    
    if (products.length > 0) {
      // Store the original order with product IDs
      this.originalProductOrder = products.map(product => product.getAttribute('data-product-id'));
      console.log(`✅ Stored original order for ${products.length} products:`, this.originalProductOrder);
    } else {
      console.log('❌ No products found for storing original order');
    }
  }



  findProductGrid() {
    // Try multiple selectors to find the product grid
    const selectors = [
      '.collection__products',
      '.collection__grid',
      '.products-grid',
      '.collection-products',
      '[data-collection-products]',
      '.collection__items',
      '.collection__products-grid',
      '.collection__grid-container',
      '.collection__products-container',
      '.collection__items-grid'
    ];
    
    for (const selector of selectors) {
      const productGrid = document.querySelector(selector);
      if (productGrid) {
        return productGrid;
      }
    }
    
    return null;
  }

  findProducts(productGrid) {
    if (!productGrid) return [];
    
    // Try to find products using different methods
    let products = [];
    
    // Method 1: Direct children
    products = Array.from(productGrid.children).filter(child => 
      child.hasAttribute('data-product-id') || 
      child.classList.contains('product-grid-item') ||
      child.classList.contains('grid__item')
    );
    
    // Method 2: If no products found, try querySelectorAll
    if (products.length === 0) {
      products = Array.from(productGrid.querySelectorAll('[data-product-id]'));
    }
    
    // Method 3: If still no products, try broader selectors
    if (products.length === 0) {
      products = Array.from(productGrid.querySelectorAll('.product-grid-item, .grid__item, [data-product-block]'));
    }
    
    return products;
  }

  addCustomSortOption() {
    console.log('🔍 Looking for sort dropdowns...');
    
    // Try multiple possible selectors
    const selectors = [
      '.collection__filter-tags--default',
      '.collection__sort__options ul',
      '[data-collection-sort-options] ul',
      '.collection__sort ul',
      '.sort-dropdown ul',
      '.collection__filter-tags',
      'ul:has(li:contains("Best selling"))',
      'ul:has(li:contains("Alphabetically"))',
      'ul:has(li:contains("Price"))',
      'ul:has(li:contains("Date"))',
      'ul li:contains("Best selling")',
      'ul li:contains("Alphabetically")',
      'ul li:contains("Price")',
      'ul li:contains("Date")'
    ];
    
    // Also try mobile-specific selectors
    const mobileSelectors = [
      '.collection__sort__option-wrapper ul',
      '.collection__sort__options .collection__filter-tags',
      '[data-collection-sort-options] .collection__filter-tags'
    ];
    
    // Combine all selectors
    const allSelectors = [...selectors, ...mobileSelectors];
    
    let sortOptions = [];
    let usedSelector = '';
    
    for (const selector of allSelectors) {
      sortOptions = document.querySelectorAll(selector);
      if (sortOptions.length > 0) {
        usedSelector = selector;
        console.log(`✅ Found ${sortOptions.length} dropdowns using selector: ${selector}`);
        break;
      }
    }
    
    if (sortOptions.length === 0) {
      console.log('❌ No sort dropdowns found with any selector');
      console.log('Available elements with "sort" in class:', document.querySelectorAll('[class*="sort"]'));
      console.log('Available elements with "filter" in class:', document.querySelectorAll('[class*="filter"]'));
      
      // Try to find by text content
      const allLists = document.querySelectorAll('ul');
      console.log('All ul elements found:', allLists.length);
      
      for (let i = 0; i < allLists.length; i++) {
        const list = allLists[i];
        const text = list.textContent.toLowerCase();
        if (text.includes('best selling') || text.includes('alphabetically') || text.includes('price') || text.includes('date')) {
          console.log(`✅ Found potential sort dropdown at index ${i}:`, list);
          sortOptions = [list];
          break;
        }
      }
      
      if (sortOptions.length === 0) {
        console.log('❌ Still no sort dropdowns found');
        return;
      }
    }
    
    sortOptions.forEach((container, index) => {
      console.log(`Processing dropdown ${index + 1}:`, container);
      
      // Check if custom option already exists
      if (container.querySelector('[data-sort="lastreceive"]')) {
        console.log('Custom option already exists, skipping');
        return;
      }

      // Create custom sort option
      const customOption = this.createSortOption('Newest First', 'lastreceive');
      container.appendChild(customOption);
      console.log('✅ Added custom sort option to dropdown', index + 1);
      
      // Debug: Log the created option
      const customInput = customOption.querySelector('input[value="lastreceive"]');
      if (customInput) {
        console.log('🔍 Custom input created with ID:', customInput.id);
        console.log('🔍 Custom input value:', customInput.value);
      }
    });
  }

  createSortOption(label, value) {
    const li = document.createElement('li');
    li.className = 'collection__filter-tag';
    
    const input = document.createElement('input');
    input.type = 'radio';
    input.name = 'sort_by_bar';
    input.value = value;
    input.className = 'collection__sort__input';
    input.setAttribute('data-sort', value);
    input.id = `filter-bar-${value}-${Date.now()}`;
    
    const labelElement = document.createElement('label');
    labelElement.className = 'collection__sort__button';
    labelElement.htmlFor = input.id;
    labelElement.textContent = label;
    
    li.appendChild(input);
    li.appendChild(labelElement);
    
    return li;
  }

  bindSortEvents() {
    console.log('🔗 Binding sort events...');
    
    // Simple, reliable event handling
    document.addEventListener('change', (e) => {
      console.log('🔄 Change event detected:', e.target.value);
      if (e.target.classList.contains('collection__sort__input') && 
          e.target.value === 'lastreceive') {
        console.log('🎯 Newest First sorting selected!');
        e.preventDefault();
        e.stopPropagation();
        
        // Perform sorting immediately
        this.performLastReceiveSort();
      } else if (e.target.classList.contains('collection__sort__input')) {
        // Log when other sort options are selected
        console.log(`🔄 Other sort option selected: ${e.target.value}`);
      }
    });
    
    // Also listen for clicks on the custom option
    document.addEventListener('click', (e) => {
      console.log('🖱️ Click event detected:', e.target);
      const customInput = document.querySelector('input[value="lastreceive"]');
      if (customInput && (e.target === customInput || e.target.closest('label[for="' + customInput.id + '"]'))) {
        console.log('🎯 Custom sort option clicked!');
        e.preventDefault();
        e.stopPropagation();
        this.performLastReceiveSort();
      }
    });
    
    // Test if our custom option exists
    setTimeout(() => {
      const customInput = document.querySelector('input[value="lastreceive"]');
      if (customInput) {
        console.log('✅ Custom input found:', customInput);
        // Add direct click handler
        customInput.addEventListener('click', () => {
          console.log('🎯 Direct click on custom input!');
          this.performLastReceiveSort();
        });
      } else {
        console.log('❌ Custom input not found!');
      }
    }, 2000);
  }
  
  performLastReceiveSort() {
    console.log('🚀 Starting custom sort...');
    
    // Keep the option selected
    const selectedInput = document.querySelector('input[value="lastreceive"]');
    if (selectedInput) {
      this.keepOptionSelected(selectedInput);
    }
    
    // Update the dropdown label to show "Newest First"
    this.updateDropdownLabel('Newest First');
    
    // Perform the actual sorting
    this.sortByLastReceive();
  }
  
  clearExistingSortIndicators() {
    // Remove any existing sort parameters from URL that might interfere
    const url = new URL(window.location);
    const existingSort = url.searchParams.get('sort_by');
    if (existingSort && existingSort !== 'lastreceive') {
      console.log(`Clearing existing sort parameter: ${existingSort}`);
    }
    
    // Also clear any visual indicators of other sorts
    document.querySelectorAll('.collection__sort__input').forEach(input => {
      if (input.value !== 'lastreceive') {
        input.checked = false;
      }
    });
  }
  
  updateDropdownLabel(text) {
    // Update the sort dropdown label
    const sortLabel = document.querySelector('.collection__sort__label');
    if (sortLabel) {
      // Find the text node and update it
      const textNode = sortLabel.childNodes[0];
      if (textNode && textNode.nodeType === Node.TEXT_NODE) {
        textNode.textContent = text;
      } else {
        // If no text node, replace the first child
        const newTextNode = document.createTextNode(text);
        if (sortLabel.firstChild) {
          sortLabel.replaceChild(newTextNode, sortLabel.firstChild);
        } else {
          sortLabel.appendChild(newTextNode);
        }
      }
    }
  }
  

  
  keepOptionSelected(selectedInput) {
    // Uncheck all other sort options
    document.querySelectorAll('.collection__sort__input').forEach(input => {
      input.checked = false;
    });
    
    // Check our selected option
    selectedInput.checked = true;
    
    // Update the sort label to show "Newest First"
    const sortLabel = document.querySelector('.collection__sort__label');
    if (sortLabel) {
      sortLabel.textContent = 'Newest First';
    }
  }

  sortByLastReceive() {
    console.log('🔄 Starting Newest First sorting...');
    
    const productGrid = this.findProductGrid();
    if (!productGrid) {
      console.log('❌ No product grid found');
      return;
    }

    const products = this.findProducts(productGrid);
    
    console.log(`📦 Found ${products.length} products to sort`);
    
    if (products.length === 0) {
      console.log('❌ No products found in the grid');
      return;
    }
    
    // Simple product ID sorting that was working before
    const productsWithData = products.map((product, index) => {
      const id = parseInt(product.getAttribute('data-product-id') || '0');
      const title = product.querySelector('.product-grid-item__title')?.textContent?.trim() || '';
      
      console.log(`Product ${index + 1}: ID=${id}, Title="${title}"`);
      
      return {
        element: product,
        id: id,
        title: title
      };
    });
    
    // Sort by product ID (newer products first)
    productsWithData.sort((a, b) => {
      return b.id - a.id; // Newer products first
    });
    
    console.log('🔄 Reordering products by newest first...');
    
    // Just show the sorted order in console - don't move anything
    console.log('Final sorted order:');
    productsWithData.forEach((product, index) => {
      console.log(`${index + 1}. ID: ${product.id}, Title: "${product.title}"`);
      
      // Add a temporary visual indicator to show sorting worked
      product.element.style.border = '2px solid red';
      setTimeout(() => {
        product.element.style.border = '';
      }, 2000);
    });
    
    console.log('✅ Sorting complete! Products should now be in newest-first order.');
  }

  extractLastReceiveDate(tagsString) {
    if (!tagsString) return null;
    
    // Split tags and look for lastReceive
    const tags = tagsString.split(',');
    const lastReceiveTag = tags.find(tag => tag.trim().startsWith('lastReceive:'));
    
    if (lastReceiveTag) {
      // Extract the date part after "lastReceive:"
      const datePart = lastReceiveTag.split(':')[1];
      if (datePart) {
        return datePart.trim();
      }
    }
    
    return null;
  }
  
  disableShopifySorting() {
    console.log('🔒 Disabling Shopify native sorting...');
    
    // Disable all native sort inputs except our custom one
    document.querySelectorAll('.collection__sort__input').forEach(input => {
      if (input.value !== 'lastreceive') {
        input.disabled = true;
      }
    });
    
    // Also disable any sort-related forms or containers
    const sortForms = document.querySelectorAll('form[action*="sort"]');
    sortForms.forEach(form => {
      form.style.pointerEvents = 'none';
    });
  }
  
  enableShopifySorting() {
    console.log('🔓 Re-enabling Shopify native sorting...');
    
    // Re-enable all native sort inputs
    document.querySelectorAll('.collection__sort__input').forEach(input => {
      input.disabled = false;
    });
    
    // Re-enable sort forms
    const sortForms = document.querySelectorAll('form[action*="sort"]');
    sortForms.forEach(form => {
      form.style.pointerEvents = '';
    });
  }
  
  resetShopifySortingState() {
    console.log('🔄 Resetting Shopify sorting state...');
    
    // Clear any active sort indicators
    document.querySelectorAll('.collection__sort__input').forEach(input => {
      input.checked = false;
    });
    
    // Reset any sort-related data attributes
    const productGrid = document.querySelector('.collection__products, .collection__grid, .products-grid');
    if (productGrid) {
      productGrid.removeAttribute('data-sort-by');
      productGrid.removeAttribute('data-sort-order');
    }
    
    // Clear any sort-related URL parameters except our own
    const currentUrl = new URL(window.location);
    const paramsToRemove = ['sort_by', 'sort_order', 'view'];
    paramsToRemove.forEach(param => {
      if (param !== 'sort_by' || currentUrl.searchParams.get('sort_by') !== 'lastreceive') {
        currentUrl.searchParams.delete(param);
      }
    });
    
    // Update URL without triggering a reload
    window.history.replaceState({}, '', currentUrl.toString());
  }
  
  checkForExistingLastReceiveSort() {
    const urlParams = new URLSearchParams(window.location.search);
    const sortBy = urlParams.get('sort_by');
    
    if (sortBy === 'lastreceive') {
      console.log('🔄 URL contains lastreceive sorting, applying automatically...');
      
      // Wait a bit for the page to fully load
      setTimeout(() => {
        this.sortByLastReceive();
        
        // Update the dropdown to show "Newest First" is selected
        const lastReceiveInput = document.querySelector('input[value="lastreceive"]');
        if (lastReceiveInput) {
          this.keepOptionSelected(lastReceiveInput);
          this.updateDropdownLabel('Newest First');
        }
      }, 1000);
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new CustomProductSorter();
});

// Also try after a short delay to ensure dropdowns are rendered
setTimeout(() => {
  new CustomProductSorter();
}, 1000);

// And try again after theme scripts load
window.addEventListener('load', () => {
  setTimeout(() => {
    new CustomProductSorter();
  }, 500);
}); 